import { Component } from '@angular/core'

@Component({
  selector: 'se-po-state-select-docs',
  templateUrl: './state-select-docs.component.html',
  styleUrls: ['./state-select-docs.component.scss'],
  standalone: false,
})
export class StateSelectDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public stateSelectComponent: any = [
    {
      Property: '@Input() country?',
      Type: 'string',
      Description: 'Current country (US, CA)',
    }
  ]
}
